let _contentsResponse;
let _productsResponse;

export default function recommendations() {
  const _getRequestOptions = (username = null, password = null) => {
    const headers = {};
    if (username && password) {
      headers.Authorization = `Basic ${btoa(`${username}:${password}`)}`;
    }
    const CFAccessClientId = process.env.REACT_APP_CF_ACCESS_CLIENT_ID;
    const CFAccessClientSecret = process.env.REACT_APP_CF_ACCESS_CLIENT_SECRET;

    if (CFAccessClientId && CFAccessClientId !== "null") {
      headers["CF-Access-Client-Id"] = CFAccessClientId;
    }
    if (CFAccessClientSecret && CFAccessClientSecret !== "null") {
      headers["CF-Access-Client-Secret"] = CFAccessClientSecret;
    }

    return {
      mode: "cors",
      method: "GET",
      headers,
    };
  };
  const _getResponse = (requestOptions, url, pages = []) => {
    return fetch(url, requestOptions)
      .then((response) => response.text())
      .then((result) => JSON.parse(result))
      .then((obj) => {
        pages = pages.concat(obj);

        return obj.links?.next?.href
          ? _getResponse(obj.links?.next?.href, pages)
          : pages;
      });
  };
  const filters =
    "filter[mtc_title_exists][condition][path]=ed_mtc_title&filter[mtc_title_exists][condition][operator]=IS%20NOT%20NULL&filter[mtc_title_exists][condition][operator]=IS%20NOT%20NULL";
  const contentFields =
    "langcode,path,ed_category_code,ed_customer_level,ed_mtc_title,ed_mtc_summary,ed_mtc_image&include=ed_mtc_image,ed_mtc_image.image&fields[ed_mtc_image]=image&fields[file--file]=uri,url";
  const productFields =
    "langcode,path,ed_listing_product_name,ed_mtc_title,ed_mtc_image&include=ed_mtc_image,ed_mtc_image.image&fields[ed_mtc_image]=image&fields[file--file]=uri,url";

  return {
    getContent: (
      base,
      urls,
      langcode,
      level,
      username = null,
      password = null,
      cacheTimeout = null
    ) => {
      return new Promise((resolve, reject) => {
        (_contentsResponse
          ? new Promise((resolve) => resolve(_contentsResponse))
          : Promise.all(
              [
                `page`,
                `ed_product_range_page`,
                `product_outlet`,
                `campaign_page`,
              ].map((ct) =>
                _getResponse(
                  _getRequestOptions(username, password),
                  `${base}/jsonapi/node/${ct}?${filters}&fields[node--${ct}]=${contentFields}`
                )
              )
            ).then((o) => {
              const merged = [].concat.apply([], o);

              _contentsResponse = {
                data: [].concat.apply(
                  [],
                  merged.map((m) => m.data)
                ),
                included: [].concat.apply(
                  [],
                  merged.map((m) => m.included)
                ),
              };

              setTimeout(
                () => (_contentsResponse = null),
                cacheTimeout || 10000
              );

              return _contentsResponse;
            })
        )
          .then((contents) => {
            const recommendations = [];

            urls.forEach((url) => {
              const a = document.createElement("a");
              a.href = url;
              const [, ...alias] = [
                base,
                ...url.substring(base.length + 1).split("/"),
              ];
              const content = contents.data.find(
                (content) =>
                  content.attributes.path.alias === `/${alias.join("/")}` &&
                  content.attributes.path.langcode === langcode
              );

              if (content) {
                const recommendation = {
                  url: url,
                  category: content.attributes.ed_category_code,
                  level:
                    content.attributes.ed_customer_level
                      ?.split(",")
                      .map((l) => l.trim()) || [],
                  title: content.attributes.ed_mtc_title,
                  body: content.attributes.ed_mtc_summary?.value,
                  image_url: null,
                  cta_url: url,
                };

                if (recommendation.body) {
                  const elm = document.createElement("div");
                  elm.innerHTML = recommendation.body.trim();
                  recommendation.body = elm.innerText;
                }

                const mediaImageId =
                  content.relationships?.ed_mtc_image?.data?.id;

                if (mediaImageId) {
                  const fileId = contents.included
                    ?.filter(Boolean)
                    .find((i) => i.id === mediaImageId)?.relationships?.image
                    ?.data?.id;

                  if (fileId) {
                    const url = contents.included
                      ?.filter(Boolean)
                      .find((i) => i.id === fileId)?.attributes?.uri?.url;

                    recommendation.image_url = url
                      ? `${a.protocol}//${a.host}${url}`
                      : null;
                  }
                }

                if (
                  !level ||
                  (level && recommendation.level.indexOf(level) !== -1)
                ) {
                  recommendations.push(recommendation);
                }
              }
            });

            resolve(recommendations);
          })
          .catch((error) => reject(error));
      });
    },
    getProduct: (
      base,
      urls,
      langcode,
      username = null,
      password = null,
      cacheTimeout = null
    ) => {
      return new Promise((resolve, reject) => {
        (_productsResponse
          ? new Promise((resolve) => resolve(_productsResponse))
          : Promise.all(
              [`ed_product_page`].map((ct) =>
                _getResponse(
                  _getRequestOptions(username, password),
                  `${base}/jsonapi/node/${ct}?${filters}&fields[node--${ct}]=${productFields}`
                )
              )
            ).then((o) => {
              const merged = [].concat.apply([], o);

              _productsResponse = {
                data: [].concat.apply(
                  [],
                  merged.map((m) => m.data)
                ),
                included: [].concat.apply(
                  [],
                  merged.map((m) => m.included)
                ),
              };

              setTimeout(
                () => (_productsResponse = null),
                cacheTimeout || 10000
              );

              return _productsResponse;
            })
        )
          .then((products) => {
            const recommendations = [];

            urls.forEach((url) => {
              const a = document.createElement("a");
              a.href = url;
              const [, ...alias] = [
                base,
                ...url.substring(base.length + 1).split("/"),
              ];
              const product = products.data.find(
                (product) =>
                  product.attributes.path.alias === `/${alias.join("/")}` &&
                  product.attributes.path.langcode === langcode
              );

              if (product) {
                const recommendation = {
                  url: url,
                  name: product.attributes.ed_listing_product_name,
                  title: product.attributes.ed_mtc_title,
                  cta_url: url,
                  image_url: null,
                };

                const mediaImageId =
                  product.relationships?.ed_mtc_image?.data?.id;

                if (mediaImageId) {
                  const fileId = products.included
                    ?.filter(Boolean)
                    .find((i) => i.id === mediaImageId)?.relationships?.image
                    ?.data?.id;

                  if (fileId) {
                    const url = products.included
                      ?.filter(Boolean)
                      .find((i) => i.id === fileId)?.attributes?.uri?.url;

                    recommendation.image_url = url
                      ? `${a.protocol}//${a.host}${url}`
                      : null;
                  }
                }

                recommendations.push(recommendation);
              }
            });

            resolve(recommendations);
          })
          .catch((error) => reject(error));
      });
    },
  };
}
